var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsColorfulConnection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6173FE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.735 22.922 11.49 19.43c-.435-.184-.614-.636-.4-1.01.215-.373.74-.526 1.175-.342l8.245 3.492c.435.184.614.636.4 1.01-.215.373-.741.526-1.175.342zM11.093 13.587c-.217-.368-.041-.817.392-1.001l8.245-3.507c.434-.184.96-.035 1.177.334.217.368.041.817-.392 1.001l-8.245 3.507c-.434.184-.96.035-1.177-.334z",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 22A5.506 5.506 0 0 1 2 16.5C2 13.467 4.467 11 7.5 11s5.5 2.467 5.5 5.5S10.533 22 7.5 22zM24.5 13A5.506 5.506 0 0 1 19 7.5C19 4.467 21.467 2 24.5 2S30 4.467 30 7.5 27.533 13 24.5 13zM24.5 30c-3.033 0-5.5-2.479-5.5-5.526C19 21.456 21.467 19 24.5 19s5.5 2.456 5.5 5.474C30 27.52 27.533 30 24.5 30z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsColorfulConnection);
export default __webpack_public_path__ + "static/media/icons-colorful-connection.bb41eac6.svg";
export { ForwardRef as ReactComponent };